import { useLocation, useNavigate } from "react-router-dom";
import MfaChallengeForm from "../components/auth/MfaChallengeForm";

/**
 * Richiede il codice 2FA quando una sessione admin è già registrata (ha un
 * fattore TOTP) ma non ha ancora raggiunto aal2 in questa sessione - es.
 * sessione ripristinata senza essere passata dal login (Auth.tsx gestisce
 * già il challenge subito dopo il signIn).
 */
export default function AdminMfaChallenge() {
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/admin/dashboard";

	return (
		<div className="container max-w-md mx-auto py-12">
			<div className="bg-card p-8 rounded-lg shadow-md">
				<h1 className="text-2xl font-bold text-foreground mb-6">
					Verifica in due passaggi
				</h1>
				<MfaChallengeForm onSuccess={() => navigate(from, { replace: true })} />
			</div>
		</div>
	);
}
